import React from 'react';
import { Icon } from '@tcc/crate';
import classNames from 'classnames';
import { getMessage } from '@tcc/i18n';
import { CategoryType } from '../../../../../types';

import styles from '../scoutingForm.css';

export type CategoryTypeItemProps = {
  categoryType: CategoryType;
  icon: unknown
  color: string;
  selected: boolean;
  testId: string;
  onClick: () => void;
  className?: string
  containerClassname?: string;
}

export function CategoryTypeItem({ categoryType, icon, color, selected, onClick, testId, containerClassname = '', className = '' }: CategoryTypeItemProps) {
  return (
    <div className={classNames(styles.categorySelectorContentItem, containerClassname)} onClick={onClick} data-test-id={testId}>
      {selected 
        ? <SelectedIcon color={color} testId={`${testId}-selected`} /> 
        : <div
          className={classNames(styles.categorySelectorContentItemIconContainer, className)}
          style={{ backgroundColor: color }}
          data-test-id={`${testId}-icon-container`}
        >
          <Icon
            className={styles.categorySelectorContentItemIcon}
            glyph={icon}
            testId={`${testId}-icon`}
          />
        </div>
      }
      <div className={styles.categorySelectorContentItemTitle} data-test-id={`${testId}-title`}>
        {getMessage(`enhancedScouting.form.category.${categoryType.toLowerCase()}`)}
      </div>
    </div>
  );
}

type SelectedIconProps = {
  color: string;
  testId: string;
}

function SelectedIcon({ color, testId }: SelectedIconProps) {
  return (
    <div 
      className={
        classNames(
          styles.categorySelectorContentItemIconContainer,
          styles.categorySelectorContentItemSelected, styles.noPadding)}
      style={{ color }}
      data-test-id={testId}
    >
      <Icon
        className={styles.categorySelectorContentItemIcon}
        glyph={Icon.set.SELECTED_CATEGORY}
        testId={`${testId}-icon`}
      />
    </div>
  );
}
